import type { FC } from "react";
import Navbar from "./Navbar";
import securityBg from "../assets/loanInMinutes/div.png";

const LockIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M22.5632 27C23.8082 24.8479 26.135 23.4 28.8 23.4V18H25.2V10.8C25.2 4.86801 20.3476 0 14.4 0C8.45243 0 3.60003 4.86801 3.60003 10.8V18H0V36H10.8V27H22.5632ZM7.20005 10.8C7.20005 6.89023 10.4065 3.60002 14.4 3.60002C18.3936 3.60002 21.6 6.89023 21.6 10.8V18H7.20005V10.8ZM34.2 30.6C34.2 27.6176 31.7823 25.2 28.8 25.2C26.4488 25.2 24.4486 26.7026 23.7072 28.7999H12.6V32.4H14.4V36H19.8V32.4H23.7072C24.4486 34.4973 26.4488 36 28.8 36C31.7823 36 34.2 33.5823 34.2 30.6ZM26.1 30.6C26.1 29.1088 27.3089 27.9 28.8 27.9C30.2912 27.9 31.5 29.1088 31.5 30.6C31.5 32.0912 30.2912 33.3 28.8 33.3C27.3089 33.3 26.1 32.0912 26.1 30.6Z" fill="currentColor" />
  </svg>
);

const UserShieldIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M1.42114 12.1963C1.6182 8.21732 2.20746 5.73521 3.97335 3.97311C5.73546 2.20721 8.21756 1.61795 12.1965 1.4209M37.4211 12.1963C37.2241 8.21732 36.6348 5.73521 34.8689 3.97311C33.1068 2.20721 30.6247 1.61795 26.6458 1.4209M26.6458 37.4209C30.6247 37.2238 33.1068 36.6346 34.8689 34.8687C36.6348 33.1066 37.2241 30.6245 37.4211 26.6455M12.1965 37.4209C8.21756 37.2238 5.73546 36.6346 3.97335 34.8687C2.20746 33.1066 1.6182 30.6245 1.42114 26.6455M29.8422 28.8946L29.4595 27.2859C29.3038 26.6332 28.9776 26.0335 28.5142 25.5481C28.0508 25.0627 27.4668 24.7091 26.822 24.5234L22.2632 23.2085V20.4289C23.9609 19.2826 25.1054 17.1396 25.1054 14.6841C25.1054 11.0215 22.5588 8.05248 19.4211 8.05248C16.2816 8.05248 13.7369 11.0215 13.7369 14.6841C13.7369 17.1396 14.8795 19.2826 16.579 20.4289V23.2085L12.0487 24.5348C11.4232 24.7179 10.8554 25.0593 10.4004 25.526C9.94535 25.9927 9.61836 26.5688 9.45104 27.1988L9.00009 28.8946" stroke="currentColor" strokeWidth="2.84211" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FileAltIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="29" height="36" viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M21.2308 19.8462C21.2308 19.4789 21.0849 19.1267 20.8252 18.8671C20.5656 18.6074 20.2134 18.4615 19.8462 18.4615H8.76923C8.40201 18.4615 8.04983 18.6074 7.79016 18.8671C7.53049 19.1267 7.38461 19.4789 7.38461 19.8462C7.38461 20.2134 7.53049 20.5656 7.79016 20.8252C8.04983 21.0849 8.40201 21.2308 8.76923 21.2308H19.8462C20.2134 21.2308 20.5656 21.0849 20.8252 20.8252C21.0849 20.5656 21.2308 20.2134 21.2308 19.8462ZM21.2308 27.2308C21.2308 26.8635 21.0849 26.5114 20.8252 26.2517C20.5656 25.992 20.2134 25.8462 19.8462 25.8462H8.76923C8.40201 25.8462 8.04983 25.992 7.79016 26.2517C7.53049 26.5114 7.38461 26.8635 7.38461 27.2308C7.38461 27.598 7.53049 27.9502 7.79016 28.2098C8.04983 28.4695 8.40201 28.6154 8.76923 28.6154H19.8462C20.2134 28.6154 20.5656 28.4695 20.8252 28.2098C21.0849 27.9502 21.2308 27.598 21.2308 27.2308Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.07692 0C3.73044 0 2.4391 0.534889 1.487 1.487C0.534888 2.4391 0 3.73044 0 5.07692V30.9231C0 32.2696 0.534888 33.5609 1.487 34.513C2.4391 35.4651 3.73044 36 5.07692 36H23.5385C24.8849 36 26.1763 35.4651 27.1284 34.513C28.0805 33.5609 28.6154 32.2696 28.6154 30.9231V10.5563C28.6154 9.85292 28.3865 9.16985 27.9618 8.60862L22.4271 1.28308C22.1259 0.884523 21.7365 0.56123 21.2893 0.338599C20.8421 0.115969 20.3494 6.73727e-05 19.8498 0H5.07692ZM2.76923 5.07692C2.76923 3.80308 3.80308 2.76923 5.07692 2.76923H18.4615V10.8868C18.4615 11.6511 19.0818 12.2714 19.8462 12.2714H25.8462V30.9231C25.8462 32.1969 24.8123 33.2308 23.5385 33.2308H5.07692C3.80308 33.2308 2.76923 32.1969 2.76923 30.9231V5.07692Z" fill="currentColor" />
  </svg>
);

const ShieldAltIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="31" height="36" viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M15.2 18V31.5C20.2667 31.5 24.0667 27 26.6 18M15.2 18V4.5L3.8 9V18M15.2 0L30.4 9C30.4 45 0 45 0 9" fill="currentColor" />
  </svg>
);

const PrivacyTipIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="36" height="39" viewBox="0 0 36 39" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M28.7142 18.4285V7.7125C28.7143 7.57718 28.6877 7.44317 28.636 7.31815C28.5842 7.19313 28.5082 7.07955 28.4125 6.98393L23.0159 1.58736C22.8232 1.39441 22.5618 1.28588 22.2891 1.28564H2.31422C2.04142 1.28564 1.7798 1.39401 1.58691 1.58691C1.39401 1.7798 1.28564 2.04142 1.28564 2.31422V34.5428C1.28564 34.8156 1.39401 35.0772 1.58691 35.2701C1.7798 35.463 2.04142 35.5714 2.31422 35.5714H16.7142M8.14279 14.9999H21.8571M8.14279 8.14279H14.9999M8.14279 21.8571H13.2856M21.8571 1.28564V7.11422C21.8571 7.38701 21.9654 7.64863 22.1583 7.84153C22.3512 8.03442 22.6128 8.14279 22.8856 8.14279H28.7142M28.7005 23.7856L33.0822 24.8982C33.5382 25.0148 33.8588 25.4296 33.8451 25.8994C33.5502 35.7702 27.8571 37.2856 27.8571 37.2856C27.8571 37.2856 22.1639 35.7702 21.8691 25.8994C21.8644 25.6708 21.9373 25.4475 22.0758 25.2657C22.2143 25.0839 22.4104 24.9543 22.6319 24.8982L27.0136 23.7856C27.5674 23.6451 28.1468 23.6451 28.7005 23.7856Z" stroke="currentColor" strokeWidth="2.57143" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UniversityIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M35.0874 9.2299L18.8849 0.228525C18.6183 0.0786986 18.3176 0 18.0118 0C17.7059 0 17.4052 0.0786986 17.1386 0.228525L0.918141 9.2299C0.342052 9.55395 0 10.148 0 10.7961V14.3967C0 15.3868 0.810124 16.197 1.80028 16.197H5.40083V28.7989H1.80028C0.810124 28.7989 0 29.609 0 30.5992V34.1997C0 35.1899 0.810124 36 1.80028 36H34.2052C35.1954 36 36.0055 35.1899 36.0055 34.1997V30.5992C36.0055 29.609 35.1954 28.7989 34.2052 28.7989H30.6047V16.197H34.2052C35.1954 16.197 36.0055 15.3868 36.0055 14.3967V10.7961C36.005 10.4771 35.9197 10.164 35.7583 9.88881C35.597 9.61361 35.3655 9.38621 35.0874 9.2299ZM12.6019 28.7989H9.00138V16.197H12.6019V28.7989ZM19.803 28.7989H16.2025V16.197H19.803V28.7989ZM18.0028 12.5964C16.5085 12.5964 15.3023 11.3902 15.3023 9.896C15.3023 8.40178 16.5085 7.19559 18.0028 7.19559C19.497 7.19559 20.7032 8.40178 20.7032 9.896C20.7032 11.3902 19.497 12.5964 18.0028 12.5964ZM27.0041 28.7989H23.4036V16.197H27.0041V28.7989Z" fill="currentColor" />
  </svg>
);

const features: { Icon: FC<{ className?: string }>; title: string; desc: string }[] = [
  {
    Icon: LockIcon,
    title: "256-bit Encryption",
    desc: "Every data point you share is protected by military-grade encryption, end-to-end.",
  },
  {
    Icon: UserShieldIcon,
    title: "Protected KYC",
    desc: "Your Aadhaar and PAN data is processed through RBI-compliant, secure verification channels.",
  },
  {
    Icon: FileAltIcon,
    title: "Secure Docs Upload",
    desc: "Documents are encrypted at rest and never shared with third parties without consent.",
  },
  {
    Icon: ShieldAltIcon,
    title: "Fraud Prevention",
    desc: "Real-time fraud detection algorithms flag suspicious activity before it can affect your account.",
  },
  {
    Icon: PrivacyTipIcon,
    title: "Privacy Compliant",
    desc: "Fully compliant with India's data protection regulations. Your data stays yours.",
  },
  {
    Icon: UniversityIcon,
    title: "Bank-Level Security",
    desc: "ISO 27001 certified infrastructure. Same security standards as India's leading banks.",
  },
];

export const SecurityNoticeSection = () => {
  return (
    <section className="py-20 bg-[#751515]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10 lg:mb-14">
          <span className="text-red-300 text-xs font-black tracking-[0.3em] uppercase mb-3">
            SECURITY
          </span>
          <div className="w-8 h-0.5 bg-red-300 mb-5" />
          <h2 className="text-4xl xl:text-5xl font-bold text-white mb-4">
            Security Comes Standard
          </h2>
          <p className="text-white/60 text-sm lg:text-base font-light">
            Your financial data is protected by the same technology that banks use. We take this seriously.
          </p>
        </div>

        {/* Feature cards — 2-col on mobile, 3-col on desktop */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-4 mb-4 lg:mb-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl p-5 lg:p-8 flex flex-col gap-3 border border-white/10"
              style={{ backgroundColor: "rgba(130, 50, 50, 0.35)" }}
            >
              <div><f.Icon className="text-white text-3xl" /></div>
              <h3 className="text-white font-bold text-sm lg:text-lg sm:mb-[-10px]">{f.title}</h3>
              <p className="text-white/60 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom banner — image with overlay */}
        <div className="relative rounded-2xl overflow-hidden h-[200px] sm:min-h-[260px] flex flex-col items-center justify-center">
          {/* Background image */}
          <img
            src={securityBg}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Dark red overlay */}
          {/* <div className="absolute inset-0" style={{ backgroundColor: "rgba(100, 15, 15, 0.78)" }} /> */}

          {/* Content */}
          <div className="relative z-10 flex flex-col items-center text-center px-2 gap-4">
            {/* Shield icon */}
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <svg width="55" height="61" viewBox="0 0 55 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.0535 0.384193C26.42 -0.128064 27.9259 -0.128064 29.2924 0.384193L50.427 8.30964C51.5782 8.74119 52.5703 9.51387 53.2706 10.5244C53.9709 11.5349 54.3461 12.7352 54.3459 13.9646V30.1567C54.346 35.2031 52.9409 40.1498 50.2879 44.4426C47.6349 48.7354 43.8389 52.2045 39.3253 54.4614L29.1989 59.5216C28.5699 59.8362 27.8762 60 27.173 60C26.4697 60 25.7761 59.8362 25.1471 59.5216L15.0206 54.4584C10.507 52.2015 6.71102 48.7323 4.05804 44.4396C1.40506 40.1468 -0.000107656 35.2001 1.17798e-06 30.1537V13.9677C-0.00076691 12.7377 0.374098 11.5368 1.07444 10.5256C1.77479 9.51451 2.76721 8.74137 3.91895 8.30964L25.0535 0.384193ZM30.1922 29.1785C31.3433 28.5138 32.2429 27.4879 32.7515 26.2598C33.2602 25.0318 33.3494 23.6702 33.0054 22.3863C32.6613 21.1024 31.9033 19.9678 30.8488 19.1586C29.7942 18.3494 28.5022 17.9108 27.173 17.9108C25.8437 17.9108 24.5517 18.3494 23.4972 19.1586C22.4426 19.9678 21.6846 21.1024 21.3405 22.3863C20.9965 23.6702 21.0857 25.0318 21.5944 26.2598C22.103 27.4879 23.0026 28.5138 24.1537 29.1785V39.0453C24.1537 39.846 24.4718 40.614 25.038 41.1802C25.6043 41.7464 26.3722 42.0645 27.173 42.0645C27.9737 42.0645 28.7417 41.7464 29.3079 41.1802C29.8741 40.614 30.1922 39.846 30.1922 39.0453V29.1785Z" fill="white" />
              </svg>

            </div>

            <h3 className="text-white font-bold text-xl xl:text-3xl">
              Your Data Is Safe With Us
            </h3>
            <p className="text-white/70 text-xs tracking-widest">
              RBI Regulated &nbsp;·&nbsp; ISO Certified &nbsp;·&nbsp; 256-bit Encrypted
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const SecurityNotice = () => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="pt-[73px]">
        <SecurityNoticeSection />
      </div>
    </div>
  );
};

export default SecurityNotice;
